export default __webpack_public_path__ + "static/media/clients-white.a6fabff4.svg";